import { AuthGuard } from '@app/guards/auth.guard';
import { AdminGuard } from '@app/guards/admin.guard';
import { AllProjectsComponent } from '@app/views/all-projects/all-projects.component';
import { MyProjectsComponent } from '@app/views/my-projects/my-projects.component';
import { CloseProjectComponent } from '@app/views/close-project/close-project.component';
import { ArchiveProjectComponent } from '@app/views/archive-project/archive-project.component';
import { ManagedProjectsComponent } from '@app/views/managed-projects/managed-projects.component';
import { CustomerApiTestComponent } from '@app/views/customer-api-test/customer-api-test.component';
import { EditProjectRetentionComponent } from '@app/views/edit-project-retention/edit-project-retention.component';
import { EditProjectInfoclassComponent } from '@app/views/edit-project-infoclass/edit-project-infoclass.component';
import { Routes } from '@angular/router';

export class RouteConfig {
  public static routes: Routes = [
    {
      path: '', component: MyProjectsComponent, pathMatch: 'full', canActivate: [AuthGuard]
    },
    {
      path: 'all-projects', component: AllProjectsComponent, canActivate: [AuthGuard]
    },
    {
      path: 'managed-projects', component: ManagedProjectsComponent, canActivate: [AuthGuard]
    },
    {
      path: 'connect-project/:pdpProjectId',
      loadChildren: LoadConnectProjectModule,
      canActivate: [AuthGuard]
    },
    {
      path: 'edit-project-retention/:pdpProjectId', component: EditProjectRetentionComponent, canActivate: [AuthGuard]
    },
    {
      path: 'edit-project-infoclass/:pdpProjectId', component: EditProjectInfoclassComponent, canActivate: [AuthGuard]
    },
    {
      path: 'close-project/:pdpProjectId', component: CloseProjectComponent, canActivate: [AuthGuard]
    },
    {
      path: 'archive-project/:pdpProjectId', component: ArchiveProjectComponent, canActivate: [AuthGuard]
    },
    {
      path: 'customer-api-test', component: CustomerApiTestComponent, canActivate: [AdminGuard]
    },
    {
      path: '**', redirectTo: ''
    }
  ];


}

export function LoadConnectProjectModule() {
  return import('@app/modules/connect-project/connect-project.module').then(m => m.ConnectProjectModule)
}
